// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  --page-margin: var(--app-narrow-margin);
  --page-border-radius: var(--app-fair-radius);
  --page-actions-padding: 5px;
  --page-friends-gutter: calc(var(--page-margin) / 2);
  --page-pictures-gutter: calc(var(--page-margin) / 2);
}

.user-details-section {
  --ion-grid-column-padding: 0px;
  margin: var(--page-margin);
}
.user-details-section .user-image-wrapper {
  max-width: 26%;
}
.user-details-section .user-info-wrapper {
  padding-left: var(--page-margin);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.user-details-section .user-info-wrapper .user-data-row {
  padding-bottom: var(--page-margin);
  flex-wrap: nowrap;
  justify-content: space-between;
}
.user-details-section .user-info-wrapper .user-data-row .user-name {
  margin: 0px 0px 5px;
  font-size: 20px;
  letter-spacing: 0.5px;
}
.user-details-section .user-info-wrapper .user-data-row .user-title {
  margin: 0px;
  color: var(--ion-color-medium);
  font-size: 16px;
}
.user-details-section .user-info-wrapper .user-data-row .membership-col {
  padding-left: var(--page-margin);
  flex-grow: 0;
}
.user-details-section .user-info-wrapper .user-data-row .user-membership {
  display: block;
  background-color: var(--ion-color-secondary);
  color: var(--ion-color-lightest);
  border-radius: var(--app-narrow-radius);
  padding: 4px 8px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}
.user-details-section .user-info-wrapper .actions-row {
  --ion-grid-columns: 10;
  --ion-grid-column-padding: var(--page-actions-padding);
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-left: calc(var(--page-actions-padding) * -1);
  margin-right: calc(var(--page-actions-padding) * -1);
}
.user-details-section .user-info-wrapper .actions-row .main-actions {
  flex-grow: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-left: calc(var(--page-actions-padding) * -1);
  margin-right: calc(var(--page-actions-padding) * -1);
  display: flex;
}
.user-details-section .user-info-wrapper .actions-row .main-actions .call-to-action-btn {
  padding: 0px var(--page-actions-padding);
  margin: 0px;
}
.user-details-section .user-info-wrapper .actions-row .secondary-actions {
  flex-grow: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
.user-details-section .user-info-wrapper .actions-row .secondary-actions .more-btn {
  --padding-start: 4px;
  --padding-end: 4px;
  margin: 0px;
}

.user-stats-section {
  --ion-grid-column-padding: 0px;
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: var(--page-margin);
  border-bottom: 1px solid var(--ion-color-light-shade);
}
.user-stats-section .user-stats-wrapper {
  text-align: center;
}
.user-stats-section .user-stats-wrapper .stat-value {
  display: block;
  padding-bottom: 5px;
  color: var(--ion-color-dark-shade);
  font-weight: 500;
  font-size: 18px;
}
.user-stats-section .user-stats-wrapper .stat-name {
  font-size: 16px;
  color: var(--ion-color-medium);
}

.details-section-title {
  font-size: 24px;
  font-weight: 500;
  color: var(--ion-color-dark-tint);
  margin: 0px 0px var(--page-margin);
}

.details-section-description {
  margin: 0;
}

.user-about-section {
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: var(--page-margin);
  border-bottom: 1px solid var(--ion-color-light-shade);
}
.user-about-section .user-description {
  color: var(--ion-color-dark-shade);
  text-align: justify;
  margin: var(--page-margin) 0px;
  font-size: 14px;
  line-height: 1.3;
}

.user-friends-section {
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: var(--page-margin);
  /* border-bottom: 1px solid var(--ion-color-light-shade); */
}
.user-friends-section .heading-row {
  margin-bottom: var(--page-margin);
  justify-content: space-between;
  align-items: center;
}
.user-friends-section .heading-row .details-section-title {
  margin: 0px;
  flex-basis: 75%;
}
.user-friends-section .heading-row .heading-call-to-action {
  /* padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4); */
  text-decoration: none;
  color: var(--ion-color-secondary);
}
.user-friends-section .friends-row {
  --ion-grid-columns: 7;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  margin-left: calc(var(--page-margin) * -1);
  margin-right: calc(var(--page-margin) * -1);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.user-friends-section .friends-row::-webkit-scrollbar {
  display: none;
}
.user-friends-section .friends-row::before, .user-friends-section .friends-row::after {
  content: "";
  flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));
}
.user-friends-section .friends-row .friend-item {
  --col-item-width: 2;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-friends-gutter);
}
.user-friends-section .friends-row .friend-item .friend-name {
  display: block;
  text-align: left;
  margin: var(--page-margin) 0px;
  font-size: 14px;
  padding-left: 4px;
  overflow: hidden;
  white-space: nowrap;
  /* Evitar salto de línea */
  text-overflow: ellipsis;
  /* Agregar tres puntos si el texto se trunca */
}

.user-photos-section {
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: calc(var(--page-margin) * 2);
}
.user-photos-section .heading-row {
  margin-bottom: var(--page-margin);
  justify-content: space-between;
  align-items: center;
}
.user-photos-section .heading-row .details-section-title {
  margin: 0px;
}
.user-photos-section .heading-row .heading-call-to-action {
  padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4);
  text-decoration: none;
  color: var(--ion-color-secondary);
}
.user-photos-section .pictures-row {
  --ion-grid-columns: 4;
  --ion-grid-column-padding: 0px;
  margin: 0px calc(var(--page-pictures-gutter) * -1);
}
.user-photos-section .pictures-row .picture-item {
  --col-item-width: 2;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-pictures-gutter) calc(var(--page-pictures-gutter) * 2);
}

::ng-deep .language-alert {
  --select-alert-color: #000;
  --select-alert-background: #FFF;
  --select-alert-margin: 16px;
  --select-alert-color: var(--ion-color-lightest);
  --select-alert-background: var(--ion-color-primary);
  --select-alert-margin: var(--app-fair-margin);
}
::ng-deep .language-alert .alert-head {
  padding-top: calc(var(--select-alert-margin) / 4 * 3);
  padding-bottom: calc(var(--select-alert-margin) / 4 * 3);
  padding-inline-start: var(--select-alert-margin);
  padding-inline-end: var(--select-alert-margin);
}
::ng-deep .language-alert .alert-title {
  color: var(--select-alert-color);
}
::ng-deep .language-alert .alert-head,
::ng-deep .language-alert .alert-message {
  background-color: var(--select-alert-background);
}
::ng-deep .language-alert .alert-wrapper.sc-ion-alert-ios .alert-title {
  margin: 0px;
}
::ng-deep .language-alert .alert-wrapper.sc-ion-alert-md .alert-title {
  font-size: 18px;
  font-weight: 400;
}
::ng-deep .language-alert .alert-wrapper.sc-ion-alert-md .alert-button {
  --padding-top: 0;
  --padding-start: 0.9em;
  --padding-end: 0.9em;
  --padding-bottom: 0;
  height: 2.1em;
  font-size: 13px;
}
::ng-deep .language-alert .alert-message {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/horizontal-list-experiences/styles/user-profile.page.scss","webpack://./src/theme/mixins/scrollbars.scss","webpack://./src/theme/mixins/inputs/select-alert.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB;EACE,uCAAA;EACA,4CAAA;EAEA,2BAAA;EACA,mDAAA;EACA,oDAAA;AAJF;;AAQA;EACE,8BAAA;EAEA,0BAAA;AANF;AAQE;EACE,cAAA;AANJ;AASE;EACE,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AAPJ;AASI;EACE,kCAAA;EACA,iBAAA;EACA,8BAAA;AAPN;AASM;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;AAPR;AAUM;EACE,WAAA;EACA,8BAAA;EACA,eAAA;AARR;AAWM;EACE,gCAAA;EACA,YAAA;AATR;AAYM;EACE,cAAA;EACA,4CAAA;EACA,gCAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAVR;AAcI;EACE,sBAAA;EACA,sDAAA;EAEA,8BAAA;EACA,iBAAA;EACA,mDAAA;EACA,oDAAA;AAbN;AAeM;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mDAAA;EACA,oDAAA;EACA,aAAA;AAbR;AAeQ;EACE,wCAAA;EACA,WAAA;AAbV;AAiBM;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AAfR;AAiBQ;EACE,oBAAA;EACA,kBAAA;EAEA,WAAA;AAhBV;;AAuBA;EACE,8BAAA;EAEA,0EAAA;EACA,kCAAA;EACA,qDAAA;AArBF;AAuBE;EACE,kBAAA;AArBJ;AAuBI;EACE,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;AArBN;AAwBI;EACE,eAAA;EACA,8BAAA;AAtBN;;AA2BA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,kCAAA;AAxBF;;AA2BA;EACE,SAAA;AAxBF;;AA2BA;EACE,0EAAA;EACA,kCAAA;EACA,qDAAA;AAxBF;AA0BE;EACE,kCAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAxBJ;;AA4BA;EACE,0EAAA;EACA,kCAAA;EACA,2DAAA;AAzBF;AA2BE;EACE,iCAAA;EACA,8BAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,WAAA;EACA,eAAA;AAzBN;AA4BI;EACE,wEAAA;EACA,qBAAA;EACA,iCAAA;AA1BN;AA8BE;EACE,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,2CAAA;ECrLF,wBAAA;EAGA,8BAAA;EACA,qBAAA;ADuJF;ACpJE;EACE,aAAA;ADsJJ;AA2BI;EAEE,WAAA;EAEA,+DAAA;AA3BN;AA8BI;EACE,mBAAA;EAEA,0EAAA;EACA,uEAAA;EACA,2EAAA;EAEA,uCAAA;AA9BN;AAgCM;EACE,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EAGA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,8CAAA;AAhCR;;AAuCA;EACE,0EAAA;EACA,4CAAA;AApCF;AAsCE;EACE,iCAAA;EACA,8BAAA;EACA,mBAAA;AApCJ;AAsCI;EACE,WAAA;AApCN;AAuCI;EACE,kEAAA;EACA,qBAAA;EACA,iCAAA;AArCN;AAyCE;EACE,qBAAA;EACA,8BAAA;EAEA,kDAAA;AAxCJ;AA0CI;EACE,mBAAA;EAEA,0EAAA;EACA,uEAAA;EACA,2EAAA;EAEA,8EAAA;AA1CN;;AAiDA;EErQE,0BAAA;EACA,+BAAA;EACA,2BAAA;EFuQA,+CAAA;EACA,mDAAA;EACA,6CAAA;AA9CF;AEzNE;EACE,qDAAA;EACA,wDAAA;EACA,gDAAA;EACA,8CAAA;AF2NJ;AExNE;EACE,gCAAA;AF0NJ;AEvNE;;EAEE,gDAAA;AFyNJ;AEpNI;EACE,WAAA;AFsNN;AEhNI;EACE,eAAA;EACA,gBAAA;AFkNN;AE/MI;EAEE,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EAEA,aAAA;EACA,eAAA;AF+MN;AAoBE;EACE,aAAA;AAlBJ","sourcesContent":["@import \"theme/mixins/scrollbars\";\r\n@import \"theme/mixins/inputs/select-alert\";\r\n\r\n// Custom variables\r\n// Note:  These ones were added by us and have nothing to do with Ionic CSS Custom Properties\r\n:host {\r\n  --page-margin: var(--app-narrow-margin);\r\n  --page-border-radius: var(--app-fair-radius);\r\n\r\n  --page-actions-padding: 5px;\r\n  --page-friends-gutter: calc(var(--page-margin) / 2);\r\n  --page-pictures-gutter: calc(var(--page-margin) / 2);\r\n}\r\n\r\n// Note:  All the CSS variables defined below are overrides of Ionic elements CSS Custom Properties\r\n.user-details-section {\r\n  --ion-grid-column-padding: 0px;\r\n\r\n  margin: var(--page-margin);\r\n\r\n  .user-image-wrapper {\r\n    max-width: 26%;\r\n  }\r\n\r\n  .user-info-wrapper {\r\n    padding-left: var(--page-margin);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    flex-wrap: nowrap;\r\n\r\n    .user-data-row {\r\n      padding-bottom: var(--page-margin);\r\n      flex-wrap: nowrap;\r\n      justify-content: space-between;\r\n\r\n      .user-name {\r\n        margin: 0px 0px 5px;\r\n        font-size: 20px;\r\n        letter-spacing: 0.5px;\r\n      }\r\n\r\n      .user-title {\r\n        margin: 0px;\r\n        color: var(--ion-color-medium);\r\n        font-size: 16px;\r\n      }\r\n\r\n      .membership-col {\r\n        padding-left: var(--page-margin);\r\n        flex-grow: 0;\r\n      }\r\n\r\n      .user-membership {\r\n        display: block;\r\n        background-color: var(--ion-color-secondary);\r\n        color: var(--ion-color-lightest);\r\n        border-radius: var(--app-narrow-radius);\r\n        padding: 4px 8px;\r\n        text-align: center;\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n      }\r\n    }\r\n\r\n    .actions-row {\r\n      --ion-grid-columns: 10;\r\n      --ion-grid-column-padding: var(--page-actions-padding);\r\n\r\n      justify-content: space-between;\r\n      flex-wrap: nowrap;\r\n      margin-left: calc(var(--page-actions-padding) * -1);\r\n      margin-right: calc(var(--page-actions-padding) * -1);\r\n\r\n      .main-actions {\r\n        flex-grow: 0;\r\n        padding-top: 0px;\r\n        padding-bottom: 0px;\r\n        margin-left: calc(var(--page-actions-padding) * -1);\r\n        margin-right: calc(var(--page-actions-padding) * -1);\r\n        display: flex;\r\n\r\n        .call-to-action-btn {\r\n          padding: 0px var(--page-actions-padding);\r\n          margin: 0px;\r\n        }\r\n      }\r\n\r\n      .secondary-actions {\r\n        flex-grow: 0;\r\n        padding-top: 0px;\r\n        padding-bottom: 0px;\r\n\r\n        .more-btn {\r\n          --padding-start: 4px;\r\n          --padding-end: 4px;\r\n\r\n          margin: 0px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-stats-section {\r\n  --ion-grid-column-padding: 0px;\r\n\r\n  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n  padding-bottom: var(--page-margin);\r\n  border-bottom: 1px solid var(--ion-color-light-shade);\r\n\r\n  .user-stats-wrapper {\r\n    text-align: center;\r\n\r\n    .stat-value {\r\n      display: block;\r\n      padding-bottom: 5px;\r\n      color: var(--ion-color-dark-shade);\r\n      font-weight: 500;\r\n      font-size: 18px;\r\n    }\r\n\r\n    .stat-name {\r\n      font-size: 16px;\r\n      color: var(--ion-color-medium);\r\n    }\r\n  }\r\n}\r\n\r\n.details-section-title {\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  color: var(--ion-color-dark-tint);\r\n  margin: 0px 0px var(--page-margin);\r\n}\r\n\r\n.details-section-description {\r\n  margin: 0;\r\n}\r\n\r\n.user-about-section {\r\n  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n  padding-bottom: var(--page-margin);\r\n  border-bottom: 1px solid var(--ion-color-light-shade);\r\n\r\n  .user-description {\r\n    color: var(--ion-color-dark-shade);\r\n    text-align: justify;\r\n    margin: var(--page-margin) 0px;\r\n    font-size: 14px;\r\n    line-height: 1.3;\r\n  }\r\n}\r\n\r\n.user-friends-section {\r\n  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n  padding-bottom: var(--page-margin);\r\n  /* border-bottom: 1px solid var(--ion-color-light-shade); */\r\n\r\n  .heading-row {\r\n    margin-bottom: var(--page-margin);\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .details-section-title {\r\n      margin: 0px;\r\n      flex-basis: 75%;\r\n    }\r\n\r\n    .heading-call-to-action {\r\n      /* padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4); */\r\n      text-decoration: none;\r\n      color: var(--ion-color-secondary);\r\n    }\r\n  }\r\n\r\n  .friends-row {\r\n    --ion-grid-columns: 7; // We want to show three friends and a half. Each friend fills 2 cols => (3.5 * 2 = 7 cols)\r\n    --ion-grid-column-padding: 0px;\r\n\r\n    flex-wrap: nowrap;\r\n    overflow-x: scroll;\r\n    will-change: scroll-position;\r\n    margin-left: calc(var(--page-margin) * -1);\r\n    margin-right: calc(var(--page-margin) * -1);\r\n\r\n    @include hide-scrollbars();\r\n\r\n    &::before,\r\n    &::after {\r\n      content: '';\r\n      // .friend-item has 8px of side padding, we need an extra 4px at the beginning and end to fill the 12px side margin of the view\r\n      flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));\r\n    }\r\n\r\n    .friend-item {\r\n      --col-item-width: 2;\r\n      // SSR fix: Override ion-col styles\r\n      flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n      width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n      max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n\r\n      padding: 0px var(--page-friends-gutter);\r\n\r\n      .friend-name {\r\n        display: block;\r\n        text-align: left;\r\n        margin: var(--page-margin) 0px;\r\n        font-size: 14px;\r\n        padding-left: 4px;\r\n\r\n\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        /* Evitar salto de línea */\r\n        text-overflow: ellipsis;\r\n        /* Agregar tres puntos si el texto se trunca */\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-photos-section {\r\n  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n  padding-bottom: calc(var(--page-margin) * 2);\r\n\r\n  .heading-row {\r\n    margin-bottom: var(--page-margin);\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .details-section-title {\r\n      margin: 0px;\r\n    }\r\n\r\n    .heading-call-to-action {\r\n      padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4);\r\n      text-decoration: none;\r\n      color: var(--ion-color-secondary);\r\n    }\r\n  }\r\n\r\n  .pictures-row {\r\n    --ion-grid-columns: 4;\r\n    --ion-grid-column-padding: 0px;\r\n\r\n    margin: 0px calc(var(--page-pictures-gutter) * -1);\r\n\r\n    .picture-item {\r\n      --col-item-width: 2;\r\n      // SSR fix: Override ion-col styles\r\n      flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n      width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n      max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n\r\n      padding: 0px var(--page-pictures-gutter) calc(var(--page-pictures-gutter) * 2);\r\n    }\r\n  }\r\n}\r\n\r\n// Alerts and in general all overlays are attached to the body or ion-app directly\r\n// We need to use ::ng-deep to access it from here\r\n::ng-deep .language-alert {\r\n  @include select-alert();\r\n\r\n  // Variables should be in a deeper selector or after the mixin include to override default values\r\n  --select-alert-color: var(--ion-color-lightest);\r\n  --select-alert-background: var(--ion-color-primary);\r\n  --select-alert-margin: var(--app-fair-margin);\r\n\r\n  .alert-message {\r\n    display: none;\r\n  }\r\n}","// Hide scrollbars: https://stackoverflow.com/a/38994837/1116959\r\n@mixin hide-scrollbars() {\r\n  // IE 10+\r\n  -ms-overflow-style: none;\r\n\r\n  // Firefox\r\n  overflow: -moz-scrollbars-none;\r\n  scrollbar-width: none;\r\n\r\n  // Safari and Chrome\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n","@mixin select-alert() {\r\n  // Default values\r\n  --select-alert-color: #000;\r\n  --select-alert-background: #FFF;\r\n  --select-alert-margin: 16px;\r\n\r\n  .alert-head {\r\n    padding-top: calc((var(--select-alert-margin) / 4) * 3);\r\n    padding-bottom: calc((var(--select-alert-margin) / 4) * 3);\r\n    padding-inline-start: var(--select-alert-margin);\r\n    padding-inline-end: var(--select-alert-margin);\r\n  }\r\n\r\n  .alert-title {\r\n    color: var(--select-alert-color);\r\n  }\r\n\r\n  .alert-head,\r\n  .alert-message {\r\n    background-color: var(--select-alert-background);\r\n  }\r\n\r\n  // iOS styles\r\n  .alert-wrapper.sc-ion-alert-ios {\r\n    .alert-title {\r\n      margin: 0px;\r\n    }\r\n  }\r\n\r\n  // Material styles\r\n  .alert-wrapper.sc-ion-alert-md {\r\n    .alert-title {\r\n      font-size: 18px;\r\n      font-weight: 400;\r\n    }\r\n\r\n    .alert-button {\r\n      // Values taken from Ionic small button preset\r\n      --padding-top: 0;\r\n      --padding-start: 0.9em;\r\n      --padding-end: 0.9em;\r\n      --padding-bottom: 0;\r\n\r\n      height: 2.1em;\r\n      font-size: 13px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
